import { createSlice } from "@reduxjs/toolkit";

const initialState = { value: 1 } 

export const changeLanguageSlice:any = createSlice({
    name: 'language',
    initialState,
    reducers: {
        changeLanguage: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { changeLanguage } = changeLanguageSlice.actions
export default changeLanguageSlice.reducer